export abstract class PaymentFeatureFlagService {
  abstract isInvoiceEnabled(): boolean;
}
